import React, { useState } from 'react';
import { ApprovalHistory, CmsPage, Kind, Panel } from './shared';

/**
 * tinycms → Approvals. Every publish, schedule and unpublish across the
 * account — accepted or refused, from the website or the agent — with who
 * approved, when, which version, and any override. Append-only on the server.
 */

const KINDS: Array<{ id: Kind | undefined; label: string }> = [
  { id: undefined, label: 'Everything' },
  { id: 'article', label: 'Articles' },
  { id: 'dataset', label: 'Datasets' },
  { id: 'site', label: 'Site theme' },
];

export const CmsHistory: React.FC = () => {
  const [kind, setKind] = useState<Kind | undefined>(undefined);
  return (
    <CmsPage
      title="Approvals"
      subtitle="Every publish, schedule and unpublish, with who approved it and the exact version."
    >
      <div className="mb-4 flex flex-wrap gap-2">
        {KINDS.map((k) => (
          <button
            key={k.label}
            onClick={() => setKind(k.id)}
            className={`rounded-full border px-3 py-1 text-sm ${
              kind === k.id
                ? 'border-cmp-bronze bg-cmp-bronze-soft text-cmp-ink'
                : 'border-cmp-line text-cmp-ink-2 hover:text-cmp-ink'
            }`}
          >
            {k.label}
          </button>
        ))}
      </div>
      <Panel>
        <ApprovalHistory kind={kind} limit={50} />
      </Panel>
    </CmsPage>
  );
};
